export default `
  mutation createTeamMember($projectId: String!, $email: String!) {
    createTeamMember(projectId: $projectId, email: $email) {
      projectId
      userId
      createTeamMemberFunction {
        id
        userId
        email
        projectId
        lastLogin
        createdAt
        user {
          id
          firstname
          lastname
          email
        }
        project {
          id
          name
          organisationId
          organisation {
            id
            name
            userId
            user {
              id
              firstname
              lastname
            }
          }
        }
      }
    }
  }
`
